export default __webpack_public_path__ + "static/media/ChuckBerry.202a37d6.mp3";